<div class="container">


  <div class="main-content p-t-10">
    <router-outlet></router-outlet>
  </div>


  <div class="m-t-20 m-b-40 text-center">
    <a href="https://hausmeisterapp.com" target="_blank">
      <img alt="" src="assets/images/logo/HausmeisterAppLogo-LightInline.svg" class="main-logo">
    </a>
  </div>
  <app-footer></app-footer>
</div>



